import { makeStyles } from 'tss-react/mui';
import { Container } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  layout: {
    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
}));

export const SiteWrapper = ({
  children,
  className = '',
  id = 'sda-main',
  ContainerProps = {},
}) => {
  const { classes, cx } = useStyles();

  return (
    <Container
      id={id}
      className={cx(classes.layout, className)}
      component="main"
      role="main"
      {...ContainerProps}
    >
      {children}
    </Container>
  );
};
